/**
 * * Режимы компонента TaskTimeEstimate
 */
export enum TaskTimeEstimateModeEnum {
  /**Режим добавления */
  Add = "add",
  /**Режим отображения */
  View = "view",
}
